<template>
  <div class="three-way-login-body">
    <van-nav-bar left-arrow @click-left="goapp" />
    <div class="three-way-first-div">
      <img :src="applogo" alt="">
      <div>欢迎登录</div>
    </div>
    <div class="three-way-two-div">
      <div class="two-item">
        <div class="reset-dropdown-menu">
          <van-dropdown-menu>
            <van-dropdown-item v-model="value" :options="option" :title="change_title" @change="changeOption" />
          </van-dropdown-menu>
        </div>
        <van-field v-model="mobile" type="number" placeholder="请输入手机号" maxlength="11" @input="mobileInput" />
      </div>
      <div class="password-item">
        <img :src="passwordType ? closeeyesicon: openeyesicon" alt="" @click="passwordType=!passwordType">
        <van-field v-model="password" :type="passwordType ? 'password' : 'text'" placeholder="请输入密码" @input="passwordInput" />
      </div>
      <div class="code-item" v-if="codeShow">
        <van-field v-model="codenum" type="text" placeholder="请输入验证码" />
        <div class="get-code-btn" @click="readygetcode">{{codetext}}</div>
      </div>
      <div class="login-btn" :class="{'login-btn-active':satisfyLoginStatus}" @click="login">
        <span>登录</span>
      </div>

    </div>
  </div>
</template>

<script>
  import { Toast } from 'vant'
  export default {
    data() {
      return {
        applogo: require('@/assets/common/app-logo.png'),
        closeeyesicon: require('@/assets/common/close-eyes-icon.png'),
        openeyesicon: require('@/assets/common/open-eyes-icon.png'),
        passwordType: true,
        satisfyLoginStatus: false,
        codeShow: false,
        value: 0,
        change_title: '+86',
        option: [
          { text: '中国大陆+86', value: 0 },
          { text: '香港+852', value: 1 },
          { text: '澳门+853', value: 2 },
          { text: '台湾+886', value: 3 },
        ],
        mobile: '',
        password: '',
        codenum: '',
        codetext: '获取验证码',
        codetime: 60,
        codesetInterval: null,
        device_id: '',
      }
    },
    created() {
      this.device_id = this.generateMixed(12)
    },
    methods: {
      changeOption(index) {
        switch (index) {
          case 0:
            this.change_title = '+86'
            break
          case 1:
            this.change_title = '+852'
            break
          case 2:
            this.change_title = '+853'
            break
          case 3:
            this.change_title = '+886'
            break
        }
      },
      mobileInput() {
        if (String(this.mobile).length == 11 && this.password != '') {
          this.satisfyLoginStatus = true
        }
      },
      passwordInput() {
        if (String(this.mobile).length == 11 && this.password != '') {
          this.satisfyLoginStatus = true
        }
      },
      startthetimer() {
        this.codetime -= 1
        this.codetext = this.codetime + 's获取'
        this.codesetInterval = setInterval(() => {
          this.codetime -= 1
          this.codetext = this.codetime + 's获取'
          if (this.codetime <= 0) {
            clearInterval(this.codesetInterval)
            this.codesetInterval = null
            this.codetext = '获取验证码'
            this.codetime = 60
          }
        }, 1000);
      },
      readygetcode() {
        if (this.codetext == '获取验证码' && this.codesetInterval == null) {
          this.$api.post('pushmsg/index/sms/send-code', { mobile: this.mobile, remark: 52, type: 52 }).then((res) => {
            Toast('请注意验证码接收')
            this.startthetimer()
          }).catch((error) => {
            for (let err in error) {
              Toast(error[err][0])
              return
            }
          })
        }
      },
      generateMixed(n) {
        var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
        var res = "";
        for (var i = 0; i < n; i++) {
          var id = Math.ceil(Math.random() * 35);
          res += chars[id];
        }
        return res;
      },
      login() {
        if (!this.satisfyLoginStatus) return
        if (!this.codeShow) {
          this.$api.post('member/index/oauth/token', { username: this.mobile, password: this.password, device_id: this.device_id }).then((res => {
            this.realLogin()
          })).catch((error) => {
            Toast(error.message)
            if (error.code == 200383) {
              this.codeShow = true
            }
          })
        } else {
          this.realLogin()
        }
      },
      realLogin() {
        this.$api.post('member/index/member/phone/login', { code: this.codenum, device_id: this.device_id, phone: this.mobile }).then((res => {
          this.$api.setToken(res.token_type + ' ' + res.token)
          this.$api.post("game/member/recharge-game/sign/url-encryption", { supplier_id: 4 }).then(gameres => {
            location.href = gameres.game_url
          })
        })).catch((error) => {
          for (let err in error) {
            Toast(error[err][0])
            return
          }
        })
      },
      goapp() {
        this.params('home', 'home', 'goBack')
      }
    }
  }
</script>

<style lang="less">
  .three-way-login-body {
    .van-hairline--bottom::after {
      border-bottom-width: 0px;
    }

    .van-nav-bar .van-icon {
      color: #333333;
    }

    .van-nav-bar__arrow {
      font-size: 18px;
    }

    .van-cell {
      padding: 14px 0 12px;
    }

    .van-dropdown-menu__title::after {
      border-color: transparent transparent currentColor currentColor;
    }

    .three-way-two-div {
      .two-item {
        display: flex;
        margin: 0 4%;
        border-bottom: 1px solid #dddddd;
        justify-content: space-between;

        .van-cell {
          flex: 1;
        }

        .reset-dropdown-menu {
          width: 48px;
          margin-right: 4%;

          .van-dropdown-menu {


            .van-cell {
              padding: 10px 16px;
            }

            .van-dropdown-menu__bar {
              box-shadow: none
            }

            .van-dropdown-menu__item {
              height: 50px;
            }

            .van-dropdown-menu__title {
              padding: 0 8px 0 0;
            }

            .van-ellipsis {
              min-width: 26px;
            }

            .van-dropdown-menu__title--active {
              color: #333333;
            }
          }
        }
      }

      .password-item {
        display: flex;
        margin: 0 4%;
        border-bottom: 1px solid #dddddd;

        img {
          width: 40px;
          margin-right: 23px;
          height: 22px;
          position: relative;
          top: 14px;
        }


      }

      .code-item {
        display: flex;
        margin: 0 4%;
        border-bottom: 1px solid #dddddd;

        .van-cell {
          padding: 14px 0 12px;
          flex: 1;
          position: static;
        }

        .get-code-btn {
          margin: 9px 0;
          width: 80px;
          text-align: center;
          font-size: 14px;
          font-weight: 500;
          color: #f14e00;
          line-height: 20px;
          padding: 6px 19px;
          border-radius: 0px 2px 2px 0px;
          border-left: 1px solid #dddddd;
        }
      }
    }
  }
</style>
<style lang="less" scoped>
  .three-way-login-body {
    .three-way-first-div {
      text-align: center;
      padding: 30px 0 80px;

      img {
        width: 20%;
        height: 20%;
        margin-bottom: 2%;
      }

      div {
        height: 25px;
        font-size: 18px;
        font-weight: 600;
        color: #333333;
        line-height: 25px;
      }
    }

    .login-btn {
      margin: 10% 4% 0;
      width: calc(100% - 8%);
      background: #d8d8d8;
      border-radius: 24px;
      text-align: center;

      span {
        display: inline-block;
        padding: 2% 0;
        font-size: 16px;
        font-weight: 400;
        text-align: left;
        color: #999999;
        line-height: 22px;
      }
    }

    .login-btn-active {
      background: linear-gradient(90deg, #ff7641, #ff0b40);

      span {
        color: #FFFFFF;
      }
    }
  }
</style>